// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum CtsGantryLogSeverityType {
  WARNING = 'Warning',
  INFORMATION = 'Information',
  ERROR = 'Error',
}
